import React, { Component } from 'react';
import Modal from 'react-modal';
import { getCandidateCv } from '../../../Api/ExtranetActions';

declare var globalSns;

class ControlCv extends Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.openOnlineCv = this.openOnlineCv.bind(this);
        this.closeOnlineCv = this.closeOnlineCv.bind(this);  
        this.printOnlineCv = this.printOnlineCv.bind(this);
    }

    componentWillMount() {
        Modal.setAppElement("body");
    }    

    openOnlineCv() {
        getCandidateCv(this.props.candidateId, this.props.jobId, globalSns.languageId, (data) => {
            this.setState({
                openOnlineCv: true,
                cvData: data
            });
        });
    }

    closeOnlineCv() {
        this.setState({openOnlineCv: false});
    }

    printOnlineCv() {
        var html = this.state.cvData.replace("</head>", "<style type='text/css'>@page {margin: 0mm 0mm 0mm 0mm;}</style></head>")
        var win = window.open("", "print");
        win.document.write(html);

        setTimeout(function () {
            win.document.close();
            win.focus();
            win.print();
            win.close();
        }, 1000);
    }

    render() {
        return (
            <div className={this.props.className}>
                <a className="subcatlink" onClick={(e) => this.openOnlineCv()}><span className="sr-only">CV</span><i className="fa fa-id-card-o" aria-hidden="true"></i></a>
                <Modal
                    isOpen={this.state.openOnlineCv}
                    onRequestClose={this.closeOnlineCv}
                    className="ReactModal"
                    overlayClassName="ReactModalOverlay"              
                >
                    <a className="print" onClick={(e) => this.printOnlineCv()}><span className="sr-only">Print</span><i className="fa fa-print" aria-hidden="true"></i></a>
                    <div className="cvform" dangerouslySetInnerHTML={{ __html: this.state.cvData }} />
                </Modal>                         
            </div>
        );
    }
}

export default ControlCv;


// WEBPACK FOOTER //
// ./src/Components/Extranet/Pages/ControlCv.js